import { gql } from '@apollo/client';

// «Tramos revisados» (2026-10-27): marca/desmarca tramos como revisados (marca
// personal). `changedAt` es la hora del gesto en el cliente: permite que un
// reintento desde la cola offline no pise un cambio posterior.
export const SET_SEGMENT_REVIEWS = gql`
  mutation SetSegmentReviews(
    $segmentIds: [ID!]!
    $reviewed: Boolean!
    $changedAt: Date
  ) {
    setSegmentReviews(
      segmentIds: $segmentIds
      reviewed: $reviewed
      changedAt: $changedAt
    ) {
      segmentId
      reviewed
      changedAt
    }
  }
`;

// «Revisado automático» (2026-11-03): estados de la actuación ligada que dan un
// tramo por revisado en esta empresa. Devuelve la lista guardada. Solo con red:
// es configuración de la empresa, no se encola.
export const SET_SEGMENT_REVIEW_AUTO_STATES = gql`
  mutation SetSegmentReviewAutoStates($states: [String!]!) {
    setSegmentReviewAutoStates(states: $states)
  }
`;
